import { createReducer, on } from '@ngrx/store';
import { BrandsState, loadBrands, loadBrandsSuccess, loadBrandsFailure, setBrands, clearBrands } from './brands.actions';

export const initialState: BrandsState = {
  brands: [],
  loading: false,
  error: null
};

export const brandsReducer = createReducer(
  initialState,
  on(loadBrands, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadBrandsSuccess, (state, { brands }) => ({
    ...state,
    brands,
    loading: false,
    error: null
  })),
  on(loadBrandsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(setBrands, (state, { brands }) => ({
    ...state,
    brands
  })),
  on(clearBrands, (state) => ({
    ...state,
    brands: [],
    error: null
  }))
);
